/* eslint-disable react/jsx-no-useless-fragment */
// features/auth/AccessDetailsProvider.js
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout } from '../../redux/slices/authSlice';
import { authTokenCookie } from '../../utils/CookieMaker';
import { getBaseUrl } from '../../utils/getUrl';
import usePostLog from '../../hooks/useLog';

export const AccessDetailsProvider = ({ children }) => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state: { auth: { isAuthenticated: boolean } }) => state.auth.isAuthenticated);
  const { sendLog, LOG_ACTIONS } = usePostLog();

  useEffect(() => {
    const authToken = authTokenCookie();
    const requiredRole = 'vocadmin';
    const userInfo = authToken ? authToken.userInfo : null;
    if (userInfo?.name && userInfo.allUserRole && userInfo.allUserRole.includes(requiredRole)) {
      // User is authenticated, dispatch login action
      const authenticated = localStorage.getItem('isLogedin');
      if (!authenticated) {
        localStorage.setItem('isLogedin', 'true');
        sendLog({ action: LOG_ACTIONS.LOGIN, payload: {} });
      }
      dispatch(login(userInfo));
    } else if (userInfo && userInfo?.name && !(userInfo.allUserRole && userInfo.allUserRole.includes(requiredRole))) {
      document.cookie.split(';').forEach((cookie) => {
        const date = new Date();
        date.setDate(date.getDate() - 1);
        document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, `=;expires=${date.toUTCString()};path=/`);
      });
      localStorage.removeItem('isLogedin');
      window.location.replace(`${getBaseUrl()}?roleAuth=failed`);
    } else {
      // Clear cookies and logout user
      document.cookie.split(';').forEach((cookie) => {
        document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
      });

      sessionStorage.clear();
      dispatch(logout());
      localStorage.removeItem('isLogedin');
      // Redirect to login page
      window.location.replace(`${getBaseUrl()}auth/login`);
    }
  }, []);

  if (!isAuthenticated) {
    return <div>Loading...</div>; // Show loading state
  }

  return <>{children}</>;
};

export default AccessDetailsProvider;
